import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import humps from 'humps';
import PusherService from 'shared/services/pusher-service';

export type CustomReportPusherEvent = {
  courseId: number;
  reportId: number;
  reportType?: string;
  generatedAt?: string;
  reportFileStatus?: number;
  reportFileUrl?: string;
};

const useCustomReportPusherEvents = (
  courseId: number | null | undefined,
  onEvent: (data: CustomReportPusherEvent) => void,
): void => {
  const pusherKey = useSelector((state: any) => state.app.configKey?.pusher);

  const onEventRef = useRef(onEvent);
  useEffect(() => { onEventRef.current = onEvent; });

  useEffect(() => {
    if (!courseId || !pusherKey) return undefined;

    const pusherChannel = PusherService.initializeCourseChannel(courseId);
    if (!pusherChannel) return undefined;

    const handler = (data: unknown) => {
      onEventRef.current(humps.camelizeKeys(data as object) as CustomReportPusherEvent);
    };

    pusherChannel.bind('custom_report_generated', handler);
    pusherChannel.bind('custom_report_failed', handler);

    return () => {
      pusherChannel.unbind('custom_report_generated', handler);
      pusherChannel.unbind('custom_report_failed', handler);
    };
  }, [courseId, pusherKey]);
};

export default useCustomReportPusherEvents;
